import { render, staticRenderFns } from "./WithdrawFunds.vue?vue&type=template&id=2e404ae4&"
import script from "./WithdrawFunds.vue?vue&type=script&lang=js&"
export * from "./WithdrawFunds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports